import { FlexView, Spacer, Title } from '@facile-it/shark-morph/components'
import React from 'react'

export namespace SubmitFeedback {
    export interface Props {
        title: React.ReactChild
        children: React.ReactNode | React.ReactNode[]
    }
}

export const SubmitFeedback: React.FC<SubmitFeedback.Props> = ({ title, children }) => {
    return (
        <React.Fragment>
            <Spacer height={2} />
            <FlexView hAlignContent="center">
                <FlexView.Item xs={5}>
                    <Title tag="h2" fontWeight="bold" fontSize="xl" fontType="alt-lg">
                        {title}
                    </Title>
                </FlexView.Item>
            </FlexView>
            <FlexView hAlignContent="center">
                <FlexView.Item xs={10}>
                    <Spacer height={0.5} />
                    {children}
                </FlexView.Item>
            </FlexView>
        </React.Fragment>
    )
}
